module.exports = new __parcel__URL__("wbd-favicon-16.6d4c0aed.png").toString();